var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Teacher as TeacherModel } from '@/models/Teacher';
import PageHeader from '@/components/page-header/PageHeader';
import { Group } from '@/models/Group';
import { GroupTypeEnum } from '@/models/GroupType';
import { fileToBase64, formatDate } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import { Token } from '@/support/Token';
import { Room } from '@/models/Room';
import AddRoomDialog from '@/views/Users/Teacher/AddRoomDialog';
import ErrorHandler from '@/support/ErrorHandler';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import { excludeRoles } from '@/support/ExcludeRoles';
import { cloneDeep } from 'lodash';
import { RolesEnum } from '@/items/Roles';
import ConfirmRemoveMfaDialog from '@/components/ConfirmRemoveMfaDialog/ConfirmRemoveMfaDialog.vue';
let Teacher = class Teacher extends Vue {
    constructor() {
        super(...arguments);
        this.isAddingRoom = false;
        this.isEditing = false;
        this.isEditingDob = false;
        this.formatDob = formatDate;
        this.teacher = new TeacherModel();
        this.teacherClone = new TeacherModel();
        this.file = null;
        this.baseImage = null;
        this.isChangingAvatar = false;
        this.passwordHidden = true;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
        // #region RemoveMFA
        this.isConfirmRemoveMfaDialogOpen = false;
        // #endregion
    }
    get canEditProfileFields() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'parnassys_status';
        });
        const status = setting && setting.value;
        switch (status) {
            case '1':
            case '2':
                return !(this.teacherClone && this.teacherClone.parnassys_id);
            default:
                return true;
        }
    }
    get canEditTeacherName() {
        if (this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT])) {
            return true;
        }
        if (this.$store.state.Auth.id === this.$route.params.id) {
            return true;
        }
        return false;
    }
    get canChangePassword() {
        if (this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.ROOT])) {
            return true;
        }
        if (this.$store.state.Auth.hasRole([RolesEnum.TEACHER]) && this.$store.state.Auth.id === this.teacher.id) {
            return true;
        }
        return false;
    }
    get breadcrumbs() {
        return [{ name: this.$tc('roles.user', 2) }, { name: this.$tc('roles.teacher', 2), path: '/teachers' }, { name: this.teacher.name || '', path: this.$route.path }];
    }
    get tableOptionsClass() {
        return {
            name: {
                singular: 'Class',
                plural: 'Class',
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    action: '/groups/{id}',
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/groups/{id}',
                },
            ],
            filters: [],
            dropdown: [],
            model: new Group().filter({ type: GroupTypeEnum.CLASS, users: [this.$route.params.id] }),
        };
    }
    get tableOptionsCoach() {
        return {
            name: {
                singular: 'Coach group',
                plural: 'Coach groups',
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    action: '/groups/{id}',
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/groups/{id}',
                },
            ],
            filters: [],
            dropdown: [],
            model: new Group().filter({ type: GroupTypeEnum.COACH, users: [this.$route.params.id] }),
        };
    }
    get tableOptionsParnassys() {
        return {
            name: {
                singular: 'Parnassys group',
                plural: 'Parnassys groups',
            },
            headers: [
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/groups/{id}',
                },
            ],
            filters: [],
            model: new Group().filter({ type: GroupTypeEnum.PARNASSYS, users: [this.$route.params.id] }),
        };
    }
    get tableOptionsRoom() {
        return {
            name: {
                singular: this.$tc('room.title', 1),
                plural: this.$tc('room.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                },
            ],
            actions: [
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: '/groups/{id}',
                },
            ],
            filters: [],
            dropdown: [],
            model: new Room().filter({ users: [this.$route.params.id] }),
        };
    }
    get isParnassysGroup() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'parnassys_status';
        });
        return !!(setting && setting.value);
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.detail.profile.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() {
        new TeacherModel()
            .include(['token', 'level', 'teacher', 'contract_hours'])
            .find(this.$route.params.id)
            .then((teacher) => {
            this.teacher = teacher;
            this.teacherClone = cloneDeep(this.teacher);
        });
    }
    update() {
        this.isEditing = false;
        if (this.password.new.length === 0) {
            this.resetPassword();
        }
        else {
            this.teacher.password = this.password.new;
        }
        const payload = this.teacher.getPayload();
        if (payload.avatar) {
            delete payload.avatar;
        }
        this.teacher
            .include(['teacher', 'roles'])
            .update(payload)
            .then((teacher) => {
            this.resetPassword();
            this.teacher = teacher;
            this.teacherClone = teacher;
            this.updateCurrentUser(teacher);
            this.$emit('update', teacher);
        });
    }
    resetPassword() {
        delete this.teacher.password;
        delete this.teacher.current_password;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
    }
    updateCurrentUser(teacher) {
        if (teacher.id === this.$store.state.Auth.id) {
            this.$store.dispatch('userAuthenticated', teacher);
        }
    }
    setToken() {
        Token.set(this.teacher.token.bearer);
        const url = `${window.location.protocol}//${window.location.host}`;
        window.location.href = url;
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    changeAvatar(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        this.file = event.target.files[0];
        fileToBase64(this.file).then((encodedFile) => {
            this.baseImage = encodedFile;
            this.isChangingAvatar = true;
        });
    }
    async changingCurrentAvatar() {
        const teacherWithDataObjects = await new TeacherModel()
            .include(['data_objects'])
            .find(this.$route.params.id);
        if (teacherWithDataObjects) {
            this.baseImage = teacherWithDataObjects.data_objects.avatar;
            this.isChangingAvatar = true;
        }
    }
    avatarChanged(imageUrl) {
        this.teacher
            .include(['teacher', 'roles'])
            .update({ avatar: imageUrl })
            .then((teacher) => {
            this.teacher.avatar = imageUrl;
            this.updateCurrentUser(teacher);
            this.$emit('update', this.teacher);
            this.$emit('closed', false);
            this.isChangingAvatar = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get canRemoveMfa() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get removeMfaEnabled() {
        return !!this.teacher.has_mfa_token;
    }
    async removeMfa() {
        if (this.teacher) {
            const teacher = await this.teacher
                .update({ mfa_token: null })
                .catch((error) => {
                ErrorHandler.network(error);
                return null;
            });
            if (teacher) {
                this.$set(this.teacher, 'has_mfa_token', false);
                if (this.teacherClone) {
                    this.$set(this.teacherClone, 'has_mfa_token', false);
                }
            }
        }
        this.isConfirmRemoveMfaDialogOpen = false;
    }
};
Teacher = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddRoomDialog,
            ImageInput,
            ConfirmRemoveMfaDialog,
        },
    })
], Teacher);
export default Teacher;
